<div *ngIf="themeData"
    class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-col items-center justify-center">
        <div>
            <div class="w-full bg-surface-0 dark:bg-surface-900 py-10 px-8 sm:px-20" style="border-radius: 53px">
                <div class="text-center mb-8">
                    <img [src]="themeData.theme_logo" alt="Logo" class="mb-8 w-50 shrink-0 mx-auto" />

                    <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-4">{{ themeData.theme_title
                        }}</div>
                    <span class="text-muted-color font-medium">{{ themeData.theme_slogan }}</span>
                </div>

                <div>

                    <div *ngIf="stage === 'login'">

                        <div class="flex flex-col gap-2 mb-4" *ngIf="validationErrors['form']">
                            <small id="form-help" class="text-red-500">{{ validationErrors['form'] | translate }}</small>
                        </div>

                        <div class="flex flex-col gap-2 mb-4">
                            <label for="email1"
                                class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">{{
                                'auth.enter_email' | translate }}</label>
                            <input pInputText id="email1" type="text" placeholder="{{ 'auth.enter_email' | translate }}"
                                class="w-full md:w-120" [(ngModel)]="credentials.email" [invalid]="validationErrors['email'] !== undefined"/>
                            <small id="username-help" class="text-red-500" *ngIf="validationErrors['email']">{{ validationErrors['email']
                                }}</small>
                        </div>

                        <div class="flex flex-col gap-2 mb-4">
                        <label for="password1"
                            class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2">{{
                            'auth.enter_password' | translate }}</label>
                        <p-password id="password1" [(ngModel)]="credentials.password" [invalid]="validationErrors['password'] !== undefined" (keypress)="onPasswordKeyPress($event)"
                            placeholder="{{ 'auth.enter_password' | translate }}" [toggleMask]="true"
                            [fluid]="true" [feedback]="false" />
                            <small id="password-help" class="text-red-500" *ngIf="validationErrors['password']">{{ validationErrors['password']
                                }}</small>
                        </div>
                    </div>

                    <div *ngIf="stage === '2fa'">
                        <div class="text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">{{
                            'auth.two_factor_authentication' | translate }}</div>

                        <div class="text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">{{
                            'auth.enter_device' | translate }}</div>
                        <p-select [options]="twoFactorDevices" [(ngModel)]="twofa.selectedDevice" optionLabel="name"
                            placeholder="{{ 'auth.enter_device' | translate }}" class="w-full md:w-120 mb-4" />

                        <div class="text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">{{ 'auth.enter_code'
                            | translate }}</div>
                        <input pInputText id="code" type="text" placeholder="{{ 'auth.enter_code' | translate }}"
                            class="w-full md:w-120 mb-8" [(ngModel)]="twofa.code" />
                    </div>


                    <div class="flex items-center justify-between mt-2 mb-8 gap-8">
                        <div class="flex items-center">
                            <span></span>
                        </div>
                        <span class="font-medium no-underline ml-2 text-right cursor-pointer text-primary">Passwort
                            vergessen?</span>
                    </div>
                    <p-button label="{{ 'auth.login' | translate }}" styleClass="w-full login-btn text-white!" (click)="login()"></p-button>

                    <p-button *ngIf="oidcEnabled" styleClass="w-full mt-3 login-btn text-white!" routerLink="/" (click)="oidcLogin()">{{
                        oidcButtonText }}</p-button>
                </div>
            </div>
        </div>
    </div>
</div>
